const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 800,
    backgroundColor: 'transparent',
    marginTop: '8px',
  },
  listItem: {
    margin: '10px 0',
    borderRadius: 4,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid transparent',
    minHeight: 70,
    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.14)' },
  },
  active: {
    border: '2px solid #0097EF',
    '&:hover': { backgroundColor: theme.palette.background.paper },
  },
  meal: {
    display: 'flex',
    alignSelf: 'center',
    height: '100%',
    fontSize: '13.5px',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/containers/meals/mobile/mealsList/MealsListStyles.js